export default __webpack_public_path__ + "static/media/video.22acab75.mp4";